module.exports = __webpack_public_path__ + "sc.svg?ed506f5afdd99e5f884903abf1da85d2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/sc.svg
// module id = 1599
// module chunks = 0